module.exports = __webpack_public_path__ + "static/media/7ICJ4.bb060ea8.jpg";